import { FetchHelper } from "shared-ts-utils-fetch";
import { CustomerSettingsDto } from "./CustomerSettings";
import { CustomerEnvironmentName } from "firefly-shared-ts-customer-environment";
import { AccessToken } from "shared-ts-utils-authentication";

export class CustomerSettingsDao {
  public readonly customerEnvironment: CustomerEnvironmentName;
  fetchHelper: FetchHelper;

  constructor(args: {
    accessToken: AccessToken;
    customerEnvironment: CustomerEnvironmentName;
  }) {
    this.customerEnvironment = args.customerEnvironment;
    this.fetchHelper = new FetchHelper({ basePath: "/api/customer-settings/" })
      .authorizationBearer(args.accessToken)
      .addHeader("Firefly-Environment", args.customerEnvironment);
    if (args.accessToken != null) {
      this.fetchHelper.authorizationBearer(args.accessToken);
    }
  }

  async getById(): Promise<CustomerSettingsDto> {
    return await this.fetchHelper.get(`get`).fetchAsJson();
  }
}
